import React from "react"
import type { FC } from "react"

import { useFormatDecimal } from "@/formatters"
import { UnitName } from "@/models/unit"

import type { ComplianceUsageIntensityProps } from "./compliance-usage-intensity.types"

export const ComplianceUsageIntensity: FC<ComplianceUsageIntensityProps> = ({
  regulations,
  usageIntensityType,
}) => {
  const { formatDecimal: formatEUI } = useFormatDecimal(
    {
      precision: 1,
    },
    {
      showUnit: false,
      unit: UnitName.KiloBritishThermalUnitPerSquareFoot,
    }
  )

  return !regulations?.length ? (
    <>--</>
  ) : (
    <>
      {regulations.map((regulation, index) => (
        <span
          key={`${regulation.regulation_name}-${regulation.effective_date}`}
        >
          {index > 0 && ", "}
          {
            // This logic is unnecessarily complicated
            // The api should not be returning effective dates when there is no regulation
            regulation.regulation_name === "No Regulation" ? (
              <>--</>
            ) : (
              formatEUI(regulation[`calculated_${usageIntensityType}`])
            )
          }
        </span>
      ))}
    </>
  )
}
